import { doc, getDoc } from 'firebase/firestore'
import { httpsCallable } from 'firebase/functions';
import { db } from '../firebase'
import { functions } from '../firebase';
import { User } from 'firebase/auth'

/**
 * Wait for user documents to be created by the onUserCreate Cloud Function
 * The Cloud Function creates:
 * 1. Global user at /users/{uid}
 * 2. Full profile at /clients/{clientKey}/directory/users/main/{uid}
 * 3. Custom claims in auth token
 */
export const waitForUserDocuments = async (user: User, maxRetries = 10): Promise<boolean> => {
  const clientKey = 'athleto';
  const globalUserRef = doc(db, 'users', user.uid);
  const userProfileRef = doc(db, `clients/${clientKey}/directory/users/main`, user.uid);
  for (let i = 0; i < maxRetries; i++) {
    try {
      // Check if both documents exist
      const [globalSnap, profileSnap] = await Promise.all([
        getDoc(globalUserRef),
        getDoc(userProfileRef)
      ]);

      if (globalSnap.exists() && profileSnap.exists()) {        return true;
      }      await new Promise(resolve => setTimeout(resolve, 1000)); // Wait 1 second
    } catch (error) {      await new Promise(resolve => setTimeout(resolve, 1000));
    }
  }  // Self-heal path: attempt idempotent repair callable for existing Auth users.
  try {    const repairCallable = httpsCallable(functions, 'repairUserDocuments');
    await repairCallable({});

    const [globalSnapAfterRepair, profileSnapAfterRepair] = await Promise.all([
      getDoc(globalUserRef),
      getDoc(userProfileRef),
    ]);

    if (globalSnapAfterRepair.exists() && profileSnapAfterRepair.exists()) {      return true;
    }
  } catch (repairError) {  }

  return false;
}

/**
 * Legacy function name for backward compatibility
 * Now just waits for Cloud Function to create documents
 */
export const createUserDocIfMissing = waitForUserDocuments;
